import { createApi } from "@reduxjs/toolkit/query/react";

import { TAGS } from "./common/tags";
import { getPaymentMethodsEndpoint } from "./endpoints/getPaymentMethods.endpoint";

import type { EmptyBaseQuery } from "./paymentApi.types";

const emptyBaseQuery: EmptyBaseQuery = async () => ({ data: null });

export const paymentApiSlice = createApi<
  EmptyBaseQuery,
  ReturnType<typeof getPaymentMethodsEndpoint>,
  "paymentApi",
  typeof TAGS.PAYMENT_METHODS
>({
  reducerPath: "paymentApi",
  baseQuery: emptyBaseQuery,
  tagTypes: [TAGS.PAYMENT_METHODS],
  endpoints: (builder) => ({
    ...getPaymentMethodsEndpoint(builder),
  }),
});

export const { useGetPaymentMethodsQuery, useGetOrderPaymentMethodQuery } = paymentApiSlice;
